import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  docRepColumns,
  transformReportData,
} from '../../../constants/DocRepConstants'
import CustomTable from '../../../shared/CustomTable'

function DoctorReportTable({
  data,
  loading,
}) {
  const { t } = useTranslation()
  const transformedData = transformReportData(data?.daily_summary)

  return (
    <div className="w-full h-full">
      <CustomTable
        data={transformedData}
        columns={docRepColumns(t)}
        isLoading={loading}
        rowClassName={rowData => {
          if (rowData.isGrandTotal) {
            return '!bg-gray-300 font-bold text-gray-800 border-t-2 border-gray-400'
          }
          return rowData.isSummary
            ? '!bg-gray-100 font-bold text-gray-700 border-t border-gray-200'
            : ''
        }}
      />
    </div>
  )
}

export default DoctorReportTable
